import { axiosFn, handleError } from "../index"
import * as URL from "../URLs"

export async function FreeLancerLevel() {
    return await axiosFn("get", URL.FREELANCERLEVELS )
        .then((res) => {
            return {
                res: res.data,
                err: null,
            }
        })
        .catch(handleError)
}
